import { Routes } from "@angular/router";
import { AppNotfoundComponent } from "../pages/app.notfound.component";
import { AppErrorComponent } from "../pages/app.error.component";
import { AppAccessdeniedComponent } from "../pages/app.accessdenied.component";
import { AppLoginComponent } from "../pages/app.login.component";
import { VisitorsComponent } from "../VisitorManagement/visitors/visitors.component";
import { AddVisitorComponent } from "../VisitorManagement/addvisitor/addvisitor.component";
import { FeesComponent } from "../FeeManagement/fees/fees.component";
import { FeeComponent } from "../FeeManagement/fee/fee.component";
import { AttendanceListComponent } from "../Attendance/attendance-list/attendance-list.component";
import { AttendanceViewComponent } from "../Attendance/attendance-view/attendance-view.component";
import { SecureGuard } from "./secureGaurd";
import { ReportsComponent } from "../reports/reports.component";
import { GlobalComponent } from "../global/global.component";
import { EnquiryListingComponent } from "../enquiry/enquiry-listing/enquiry-listing.component";
import { AddEnquiryComponent } from "../enquiry/add-enquiry/add-enquiry.component";
import { AttendenceReportComponent } from "../reports/attendence-report/attendence-report.component";
import { AdmissionReportComponent } from "../reports/admission-report/admission-report.component";
import { DefaulterReportComponent } from "../reports/defaulter-report/defaulter-report.component";
// BOOKING SLOTS COMPONENTS
import { BookingsComponent } from "../bookings/bookings/bookings.component";
import { BookingComponent } from "../bookings/booking/booking.component";
import { BookingSlotsComponent } from "../bookingSlots/booking-slots/booking-slots.component";
import { BookingSlotComponent } from "../bookingSlots/booking-slot/booking-slot.component";
import { TrainingAttendenceReportComponent } from "../reports/training-attendence-report/training-attendence-report.component";
import { NewMemberReportComponent } from "../reports/new-member-report/new-member-report.component";
import { TrainerDefaulterReportComponent } from "../reports/trainer-defaulter-report/trainer-defaulter-report.component";
import { DailyClosingReportComponent } from '../reports/daily-closing-report/daily-closing-report.component';
import { CheckInReportComponent } from "../reports/check-in-report/check-in-report.component";
import { UsersAttendanceReportComponent } from "../reports/users-attendance-report/users-attendance-report.component";
import { TrainerAttendanceReportComponent } from "../reports/trainer-attendance-report/trainer-attendance-report.component";

import { AppLoginAdminComponent } from "../pages/app.loginAdmin.component";
import { LockListComponent } from "../lock-list/lock-list.component";
import { RegisterBranchFromCompanyComponent } from "../setting/BranchManagement/register-branch-from-company/register-branch-from-company.component";
import { ActivityLogsComponent } from "app/activity-logs/activity-logs.component";


import { DesignationManagementComponent } from '../hr-pay-management/designation-management/designation-management.component';
import { EmployeeSalaryManagementComponent } from '../hr-pay-management/employee-salary-management/employee-salary-management.component';
import { PaySalaryToEmployeesComponent } from '../hr-pay-management/components/pay-salary-to-employees/pay-salary-to-employees.component';

import { AddProductComponent } from '../products/add-product/add-product.component';
import { ProductCategoryComponent } from '../products/product-category/product-category.component';
import { ProductCategoriesComponent } from '../products/product-categories/product-categories.component';
import { PointOfSaleComponent } from '../Sales/point-of-sale/point-of-sale.component';
import { SaleOrdersComponent } from '../Sales/sale-orders/sale-orders.component';
import { EmployeesListingComponent } from '../Employees/employees-listing/employees-listing.component';
import { AddEmployeeComponent } from '../Employees/add-employee/add-employee.component';
import { SupplierListingComponent } from '../supplier/supplier-listing/supplier-listing.component';
import { AddSupplierComponent } from '../supplier/add-supplier/add-supplier.component';
import { PurchaseOrderComponent } from '../supplier/purchase-order/purchase-order.component';
import { PurchaseOrdersComponent } from '../supplier/purchase-orders/purchase-orders.component';
import { ProductsListingComponent } from "../products/products-listing/products-listing.component";
import { SupplierComponent } from '../supplier/supplier.component';
import { UpdateStockCountComponent } from '../products/update-stock-count/update-stock-count.component';
import { PettyCashComponent } from "app/petty-cash/petty-cash.component";
import { TrainingSessionsComponent } from "app/training-sessions/training-sessions.component";
import { SelfSessionsComponent } from "app/self-sessions/self-sessions.component";
import { TrainerDashboardComponent } from "app/trainer-dashboard/trainer-dashboard.component";
import { DashboardComponent } from "app/dashboard/dashboard.component";
import { AssetsComponent } from "app/assets-management/assets.component";
import { AddAssetComponent } from "app/assets-management/add-assets/add-assets.component";
import { AssetDetailsComponent } from "app/assets-management/asset-details/asset-details.component";
import { FeesApprovalComponent } from "app/FeesApproval/feesApproval.component";

export const SECURE_ROUTES: Routes = [
    {
        path: "",
        loadChildren: () => import('app/members/members.module').then(m => m.MembersModule),
    },
    {
        path: "members",
        loadChildren: () => import('app/members/members.module').then(m => m.MembersModule),
    },
    {
        path: "member",
        loadChildren: () => import('app/members/members.module').then(m => m.MembersModule),
        data: { some_data: "some value" },
    },
    {
        path: "trainers",
        loadChildren: () => import('app/trainer/trainer.module').then(m => m.TrainerModule),
    },
    {
        path: "enquiry-listing",
        loadChildren: () => import('app/enquiry/enquiry.module').then(m => m.EnquiryModule),
        canActivate: [SecureGuard],
    },
    // {
    //     path: "add-enquiry",
    //     component: AddEnquiryComponent,
    // },
    // {
    //     path: "add-enquiry/:id",
    //     component: AddEnquiryComponent,
    // },
    {
        path: "activity-logs",
        component: ActivityLogsComponent,
    },
    {
        path: "dashboard",
        component: DashboardComponent,
    },
    {
        path: "assets-management",
        component: AssetsComponent,
    },
    {
        path: "add-assets",
        component: AddAssetComponent,
    },
    {
        path: "asset-details",
        component: AssetDetailsComponent,
    },
    {
        path: "visitors",
        loadChildren: () => import('app/VisitorManagement/visitor.module').then(m => m.VisitorModule),
        canActivate: [SecureGuard],
    },
    // {
    //     path: "add-visitor",
    //     component: AddVisitorComponent,
    // },
    // {
    //     path: "visitor/:id",
    //     component: AddVisitorComponent,
    // },
    // {
    //     path: "accounts",
    //     component: FeesComponent,
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "account",
    //     component: FeeComponent,
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "account/:id",
    //     component: FeeComponent,
    //     canActivate: [SecureGuard],
    // },
    {
        path: "attendance",
        loadChildren: () => import('app/Attendance/attendance.module').then(m => m.AttendanceModule),
        canActivate: [SecureGuard],
    },
    {
        path: "attendance/:id",
        component: AttendanceViewComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "settings",
        loadChildren: () => import('app/setting/setting.module').then(m => m.SettingModule),
    },
    {
        path: "reports",
        loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [SecureGuard],
    },
    {
        path: "analytics",
        loadChildren: () => import('app/analytics/analytics.module').then(m => m.AnalyticsModule),
        canActivate: [SecureGuard],
    },
    {
        path: "services",
        loadChildren: () => import('app/services/services.module').then(m => m.ServicesModule),
        canActivate: [SecureGuard],
    },
    { path: 'assets/asset/:id', component: AssetDetailsComponent },
    // {
    //     path: "check-In-Report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "users-attendance-report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "attendence-Report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "trainer-attendance-Report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "admission-Report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    // },
    // {
    //     path: "training-attendence-Report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "new-member-report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "daily-closing-report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    // {
    //     path: "trainer-defaulter-report",
    //     loadChildren: () => import('app/reports/reports.module').then(m => m.ReportsModule),
    //     canActivate: [SecureGuard],
    // },
    {
        path: "package-Builders",
        loadChildren: () => import('app/packageBuilder/package-builder.module').then(m => m.PackageBuilderModule),
        canActivate: [SecureGuard],
    },
    {
        path: "requests-management",
        loadChildren: () => import('app/requests-management/request-mangement.module').then(m => m.RequestMangementModule),
        canActivate: [SecureGuard],
    },
    {
        path: "notifications",
        loadChildren: () => import('app/notification-center/notifications-management.module').then(m => m.NotificationsManagementModule),
        canActivate: [SecureGuard],
    },
    // {
    //     path: "defaulter-Report",
    //     component: DefaulterReportComponent,
    //     canActivate: [SecureGuard],
    // },
    {
        path: "globals",
        component: GlobalComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "hr-management",
        component: DesignationManagementComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "designation-management",
        component: DesignationManagementComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "employee-salary",
        component: EmployeeSalaryManagementComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "issue-salary",
        component: PaySalaryToEmployeesComponent,
        canActivate: [SecureGuard],
    },
    {
        //  PATH TO PRODUCT LISTING
        path: "products-listing",
        component: ProductsListingComponent,
        canActivate: [SecureGuard],
    },
    //  PATH TO ADD & EDIT PRODUCT
    {
        path: "product",
        component: AddProductComponent,
    },
    {
        path: "product/:id",
        component: AddProductComponent,
    },

    //  PATH TO PRODUCT CATEGORIES LISTINGS
    {
        path: "product-categories",
        component: ProductCategoriesComponent,
        canActivate: [SecureGuard],
    },
    //  PATH TO ADD & EDIT PRODUCT CATEGORIES
    {
        path: "product-category",
        component: ProductCategoryComponent,
    },
    {
        path: "product-category/:id",
        component: ProductCategoryComponent,
    },

    //  PATH TO POS
    {
        path: "point-of-sale",
        component: PointOfSaleComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "point-of-sale/:id",
        component: PointOfSaleComponent,
    },

    {
        path: "sale-orders",
        component: SaleOrdersComponent,
        canActivate: [SecureGuard],
    },

    //  PATH TO EMPLOYEES LISTING
    {
        path: "employees-listing",
        component: EmployeesListingComponent,
        canActivate: [SecureGuard],
    },
    //  PATH TO ADD & EDIT EMPLOYEES
    {
        path: "employee",
        component: AddEmployeeComponent,
    },
    {
        path: "employee/:id",
        component: AddEmployeeComponent,
    },
    //  PATH TO SUPPLIER LISTING
    {
        path: "suppliers-listing",
        component: SupplierListingComponent,
        canActivate: [SecureGuard],
    },

    //  PATH TO ADD & EDIT SUPPLIER
    {
        path: "supplier",
        component: AddSupplierComponent,
    },
    {
        path: "supplier/:id",
        component: AddSupplierComponent,
    },

    //  PATH TO PURCHASE ORDER
    {
        path: "purchase-order",
        component: PurchaseOrderComponent,
    },
    {
        path: "purchase-order/:id",
        component: PurchaseOrderComponent,
    },

    // PATH TO PURCHASE ORDERS
    {
        path: "purchase-orders",
        component: PurchaseOrdersComponent,
        canActivate: [SecureGuard],
    },

    //  PATH TO Update Stock Count
    {
        path: "update-products-inventory",
        component: UpdateStockCountComponent,
        canActivate: [SecureGuard],
    },

    // PATH TO BOOKING SLOTS SET HERE
    {
        path: "slots",
        loadChildren: () => import('app/bookingSlots/booking-slots-management.module').then(m => m.BookingSlotsManagementModule),
        canActivate: [SecureGuard],
    },
    {
        // path: "bookings",
        // component: BookingsComponent,
        // canActivate: [SecureGuard],
        path: "bookings",
        loadChildren: () => import('app/bookings/bookings-management.module').then(m => m.BookingsManagementModule),
        canActivate: [SecureGuard],
    },
    {
        // path: "bookings",
        // component: BookingsComponent,
        // canActivate: [SecureGuard],
        path: "trainer",
        loadChildren: () => import('app/trainer/trainer.module').then(m => m.TrainerModule),
        canActivate: [SecureGuard],
    },

    {
        path: "locked-listing",
        component: LockListComponent,
        canActivate: [SecureGuard],
    },

    {
        path: "petty-cash",
        component: PettyCashComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "training-sessions",
        component: TrainingSessionsComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "self-sessions",
        component: SelfSessionsComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "trainer-dashboard",
        component: TrainerDashboardComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "feesApproval",
        component: FeesApprovalComponent,
        canActivate: [SecureGuard],
    },

    { path: "error", component: AppErrorComponent },
    { path: "accessdenied", component: AppAccessdeniedComponent },
    { path: "404", component: AppNotfoundComponent },
    { path: "login", component: AppLoginComponent },
    { path: "loginAdmin", component: AppLoginAdminComponent },
    { path: "**", redirectTo: "/404" },
];
